export function publicationProgressPercent(row: {
  completedBpas: number;
  bpaCount: number;
}): number;
export function publicationProgressPercent(row: {
  completedBpas?: number;
  bpaCount?: number;
}): number | undefined;
export function publicationProgressPercent(row: {
  completedBpas?: number;
  bpaCount?: number;
}): number | undefined {
  if (row.bpaCount === undefined || row.completedBpas === undefined) return undefined;
  if (row.bpaCount === 0) return 0;
  return Math.round((row.completedBpas / row.bpaCount) * 100);
}
